import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Bars3Icon, UserIcon, BriefcaseIcon, HomeIcon, PhoneIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { FaBloggerB } from "react-icons/fa";
import './Header.css';

const Header = () => {
    const [menu, setMenu] = useState(true);

    window.onscroll = function () { myFunction() };

    function myFunction() {
        if (document.documentElement.scrollTop > 50) {
            document.getElementById("navBg").classList.add("bgforNav");
        }
        else {
            document.getElementById("navBg").classList.remove("bgforNav");
        }
    }

    return (
        <nav id='navBg' className='md:flex lg:flex items-center justify-around px-12'>

            <div onClick={() => setMenu(!menu)} className="h-6 w-6 cursor-pointer md:hidden absolute top-4 left-2">
                {
                    menu ? <Bars3Icon /> : <XMarkIcon />
                }
            </div>
            <div>
                <p>Logo</p>
            </div>
            <ul className={`link-list md:flex absolute md:static top-10 left-1 ${menu ? 'hidden' : 'block'}`}>
                <li className='md:mr-5 mr-0'>
                    <NavLink to="/home" className={`flex items-center ({ isActive }) => isActive ? 'active' : undefined`}>
                        <HomeIcon className='w-4 h-4 mr-1'></HomeIcon>
                        <span>Home</span>
                    </NavLink>
                </li>
                <li className='md:mr-5 mr-0'>

                    <NavLink to="/about" className="flex items-center">
                        <UserIcon className='w-4 h-4 mr-1'></UserIcon>
                        <span>About</span>
                    </NavLink>
                </li>
                <li className='md:mr-5 mr-0'>
                    <NavLink to="/portfolio" className="flex items-center ">
                        <BriefcaseIcon className='w-4 h-4 mr-1'></BriefcaseIcon>
                        <span>Portfolio</span>
                    </NavLink>
                </li>
                <li className='md:mr-5 mr-0'>
                    <NavLink to="/myblog" className="flex items-center ">
                        <FaBloggerB className='w-4 h-4 mr-1'></FaBloggerB>
                        <span>My Blog</span>
                    </NavLink>
                </li>
                <li className='md:mr-5 mr-0'>
                    <NavLink to="/contact" className="flex items-center">
                        <PhoneIcon className='w-4 h-4 mr-1'></PhoneIcon>
                        <span>Contact</span>
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

export default Header; 